module.exports = __webpack_public_path__ + "img/more_filters.537dfbcc.svg";